import * as angular from 'angular';

(function () {
    'use strict';

    angular.module('app').service('fcfsBookingService', fcfsBookingService);

    function fcfsBookingService(storageService) {
        var PATH_PREFIX = 'app/fcfs-booking/';
        var STORAGE_PREFIX = 'wizard_fcfs-booking_';
        var BROADCAST = {
            WIZARD_RESTART: STORAGE_PREFIX + 'restarted'
        };

        var stages = {
            1: {
                title: 'Select network point',
                page: PATH_PREFIX + 'fcfs-booking-stage-one.html'
            },
            2: {
                title: 'Specify Booking',
                page: PATH_PREFIX + 'fcfs-booking-stage-two.html'
            },
            3: {
                title: 'Confirm',
                page: PATH_PREFIX + 'fcfs-booking-stage-three.html'
            }
        };

        var pages = {
            inputSummary: PATH_PREFIX + 'input-summary.html',
            succesful: PATH_PREFIX + 'succesful.html',
            errorPage: PATH_PREFIX + 'error-page.html'
        };

        var capacity = {
            unit: {
                KWH_H: 'kWh/h',
                KWH_D: 'kWh/d'
            }
        };

        var CHARGE_TYPES = [
            'REGULATED',
            'MEASUREMENT',
            'BIOGAS',
            'OPERATING',
            'ACCOUNTING',
            'GAS_QUALITY_CONVERSION',
            'AUCTION_SURCHARGE',
            'TOTAL',
            'BILLING',
            'BALANCING_CHARGE',
            'COMMODITY_FEE'
        ];

        var bookingError = '';

        //If Wizard is called from dashboard
        var networkPoint;

        var selectedAlternative = null;

        return {
            STORAGE_PREFIX: STORAGE_PREFIX,
            BROADCAST: BROADCAST,
            CHARGE_TYPES: CHARGE_TYPES,
            stages: stages,
            pages: pages,
            bookingError: bookingError,
            capacity: capacity,
            reset: reset,
            getAllStages: getAllStages,
            getStageOne: getStageOne,
            setStageOne: setStageOne,
            getStageTwo: getStageTwo,
            setStageTwo: setStageTwo,
            getStageThree: getStageThree,
            setStageThree: setStageThree,
            getSuccess: getSuccess,
            setSuccess: setSuccess,
            setNetworkPoint: setNetworkPoint,
            getNetworkPoint: getNetworkPoint,
            resetAllStagesAfter: resetAllStagesAfter,
            selectedAlternative: selectedAlternative,
            tsoMaintenanceMessages: {}
        };

        function reset() {
            deleteAll();
        }

        function getAllStages() {
            return {
                stageOne: getStageOne(),
                stageTwo: getStageTwo(),
                stageThree: getStageThree()
            };
        }

        function getStageOne() {
            return parseData(fetch('stageOne'));
        }

        function setStageOne(data) {
            store('stageOne', data);
        }

        function getStageTwo() {
            return parseData(fetch('stageTwo'));
        }

        function setStageTwo(data) {
            store('stageTwo', data);
        }

        function getStageThree() {
            return parseData(fetch('stageThree'));
        }

        function setStageThree(data) {
            store('stageThree', data);
        }

        function getSuccess() {
            return parseData(fetch('success'));
        }

        function setSuccess(data) {
            store('success', data);
        }

        function store(key, value) {
            storageService.storeToSession(parseKey(key), value);
        }

        function fetch(key) {
            return storageService.fetchFromSession(parseKey(key));
        }

        function resetAllStagesAfter(stage: number) {
            if (stage === 1) {
                storageService.removeFromSessionWithPrefix(
                    STORAGE_PREFIX + 'stageTwo'
                );
            }
            if (stage === 2) {
                storageService.removeFromSessionWithPrefix(
                    STORAGE_PREFIX + 'stageThree'
                );
            }
        }

        function deleteAll() {
            storageService.removeFromSessionWithPrefix(STORAGE_PREFIX);
        }

        function parseKey(key) {
            return STORAGE_PREFIX + key;
        }

        function parseData(stage) {
            return stage ? stage : {};
        }

        function setNetworkPoint(netPoint) {
            networkPoint = netPoint;
        }
        function getNetworkPoint() {
            return networkPoint;
        }
    }
})();
